<template>
    <b-modal id="modal_conflict_sync" no-close-on-backdrop centered hide-header hide-footer>
        <div class="conflict-sync">
            <div class="conflict-sync-icon">
                <span class="icon icon-conflict-sync"></span>
            </div>
            <div class="conflict-sync-description">
                <h2 tabindex="0">This project is in conflict and did not sync.</h2>
                <p tabindex="0">There is another version of this project that was synchronized on a different device
                    while you were offline. Please choose the version that you want to keep.</p>
            </div>
            <div class="conflict-sync-action">
                <b-button @click="onKeepVersion" variant="primary">Keep This Version</b-button>
                <b-button @click="onDiscardVersion" variant="light">Discard This Version</b-button>
                <b-button @click="onCancel">Cancel</b-button>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import {EventBus, Project, Storage} from "../Utils";
    import ConflictSync from "../Utils/conflict-sync";

    export default {
        name: "ModalConflictSync",
        data() {
            return {
                project: null,
                projectIndex: null,
            }
        },
        created() {
            EventBus.$on(ConflictSync.EVENT_CONFLICT_SYNC_SHOW, (p) => {
                this.project = p.project;
                this.projectIndex = p.index;
                this.$bvModal.show("modal_conflict_sync")
            })
            EventBus.$on(ConflictSync.EVENT_CONFLICT_SYNC_HIDE, () => {
                this.$bvModal.hide("modal_conflict_sync")
            })
        },
        methods: {
            onKeepVersion() {
                const {project, projectIndex} = this

                Project.syncProject(project, projectIndex, this.isOffline, true).then(response => {
                    Storage.replaceProject(response.index, response.project);
                    this.onCancel();

                    this.$eventHub.$emit('keep-version-project', {index: response.index, project: response.project})
                }).catch(error => {
                    this.$eventHub.$emit('keep-version-project', {error})
                })
            },
            onDiscardVersion() {
                const {project, projectIndex} = this

                Project.getProject(project.projectId).then(p => {
                    Storage.replaceProject(projectIndex, p);
                    this.onCancel();

                    this.$eventHub.$emit('discard-project', {index: projectIndex, project})
                }).catch(error => {
                    this.$eventHub.$emit('discard-project', {error})
                })
            },
            onCancel() {
                this.project = null;
                this.projectIndex = null;
                ConflictSync.hide();
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"
    @import "~@/core/Styles/mixins.styl"

    .conflict-sync
        padding 20px 0

        & > *
            display flex
            flex 1

        &-icon
            justify-content center
            align-items flex-end
            height 200px

        &-description
            flex-direction column
            padding 15px 0

            & > *
                text-align center

            h2
                font font-poppins-semibold
                font-size 21px
                color color-black

            p
                font font-sourcesans-regular
                font-size 16px
                color color-4

        &-action
            flex-direction column

            .btn
                margin-top 15px
</style>